import { useSearchSlice } from './slice';

export function GlobalSearch() {
  useSearchSlice();

  return null;
}
